/* Icespheric videos: silent loops that play only while on screen, and in feature strips and story steps only while their part is showing.
   Each start skips the short fade-in so a clip opens on a picture rather than black. A video the viewer pauses stays paused. Plain JavaScript. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SKIP = 0.32;

  function init() {
    if (window.IceVideoReady) return;
    window.IceVideoReady = true;
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-ice-vid]'));
    if (!vids.length) return;

    function shotOf(v) { return v.closest('[data-shot]'); }
    function btnOf(v) {
      var slide = v.closest('.ice-pdp__slide');
      return slide ? slide.querySelector('[data-vid-toggle]') : null;
    }
    function label(v) {
      var b = btnOf(v);
      if (!b) return;
      b.classList.toggle('is-paused', v.paused);
      b.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
    }
    // Nothing starts until the page has loaded, or a moment after it can be read, so videos never hold up the photos and text.
    var loaded = document.readyState === 'complete';
    function allowed(v) {
      if (!loaded || v.getAttribute('data-held') === '1' || document.hidden || v.getAttribute('data-seen') !== '1') return false;
      var shot = shotOf(v);
      return !shot || shot.classList.contains('is-on');
    }
    function start(v, fromTop) {
      if (fromTop || v.currentTime < SKIP) {
        try { v.currentTime = SKIP; } catch (e) {}
      }
      v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () {
        label(v);
        // Some phones turn down the first attempt while the page is still busy, so try again shortly.
        var tries = Number(v.getAttribute('data-tries') || 0);
        if (tries < 3) {
          v.setAttribute('data-tries', String(tries + 1));
          setTimeout(function () { sync(v, false); }, 800 * (tries + 1));
        }
      });
    }
    function sync(v, fromTop) {
      if (allowed(v)) {
        if (v.paused || fromTop) start(v, fromTop);
      } else if (!v.paused) {
        v.pause();
      }
    }

    vids.forEach(function (v) {
      v.muted = true;
      if (reduce) v.setAttribute('data-held', '1');
      var b = btnOf(v);
      if (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          if (v.paused) {
            v.removeAttribute('data-held');
            start(v, false);
          } else {
            v.setAttribute('data-held', '1');
            v.pause();
          }
        });
      }
      v.addEventListener('play', function () { label(v); });
      v.addEventListener('playing', function () { v.classList.add('is-live'); v.removeAttribute('data-tries'); });
      v.addEventListener('pause', function () { label(v); });
      label(v);
    });

    if ('IntersectionObserver' in window) {
      // On screen means at least half the video is showing, or it fills at least half the screen (tall banners on phones).
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var shown = en.isIntersecting && (en.intersectionRatio >= 0.5 || en.intersectionRect.height >= window.innerHeight * 0.5);
          en.target.setAttribute('data-seen', shown ? '1' : '0');
          sync(en.target, false);
        });
      }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });
      vids.forEach(function (v) { io.observe(v); });
    }

    // Features: start a clip from the top each time its feature comes round, and pause it when the next one takes over.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (records) {
        records.forEach(function (r) {
          var v = r.target.querySelector('video[data-ice-vid]');
          if (!v) return;
          var on = r.target.classList.contains('is-on');
          var was = (' ' + (r.oldValue || '') + ' ').indexOf(' is-on ') !== -1;
          if (on !== was) sync(v, on);
        });
      });
      vids.forEach(function (v) {
        var shot = shotOf(v);
        if (shot) mo.observe(shot, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
      });
    }

    function syncAll() { vids.forEach(function (v) { sync(v, false); }); }
    function ready() {
      if (loaded) return;
      loaded = true;
      syncAll();
    }
    if (!loaded) {
      window.addEventListener('load', ready);
      // Slow third-party scripts can hold the load event back for a long time, so don't wait more than a moment after the page is readable.
      setTimeout(ready, 1200);
    }
    // A few safety checks in the first seconds, and on the first touch or scroll, catch any video that should be playing but isn't.
    [2500, 5000, 9000].forEach(function (ms) { setTimeout(syncAll, ms); });
    ['touchstart', 'scroll', 'pointerdown'].forEach(function (name) {
      window.addEventListener(name, syncAll, { passive: true, once: true });
    });

    document.addEventListener('visibilitychange', function () {
      vids.forEach(function (v) { sync(v, false); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
